import React, { FC } from "react";
import cx from "classnames";
import ResizeDetector from "react-resize-detector";
import AppMain from "../AppMain";
import { useAppSelector } from "config/hooks";

const Main: FC = () => {
  const colorScheme = useAppSelector((state) => state.ThemeOptions.colorScheme);
  const enableFixedHeader = useAppSelector((state) => state.ThemeOptions.enableFixedHeader);
  const enableMobileMenu = useAppSelector((state) => state.ThemeOptions.enableMobileMenu);
  const enableFixedFooter = useAppSelector((state) => state.ThemeOptions.enableFixedFooter);
  const enableFixedSidebar = useAppSelector((state) => state.ThemeOptions.enableFixedSidebar);
  const enableClosedSidebar = useAppSelector((state) => state.ThemeOptions.enableClosedSidebar);
  const enablePageTabsAlt = useAppSelector((state) => state.ThemeOptions.enablePageTabsAlt);

  return (<ResizeDetector
    handleWidth
    render={({ width = 0 }) => (
        <div
          className={cx("app-container app-theme-" + colorScheme,
            { "fixed-header": enableFixedHeader },
            { "fixed-sidebar": enableFixedSidebar || width < 1250 },
            { "fixed-footer": enableFixedFooter },
            { "closed-sidebar": enableClosedSidebar || width < 1250 },
            { "closed-sidebar-mobile": width < 1250 },
            { "sidebar-mobile-open": enableMobileMenu },
            { "body-tabs-shadow-btn": enablePageTabsAlt }
          )}
        >
          <AppMain />
        </div>
    )}
  />);
};

export default Main;
